export default __webpack_public_path__ + "static/media/inter-v2-latin-regular.b0a0c6c9.eot";